import React from 'react';
import { Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faClock, faStore } from '@fortawesome/free-solid-svg-icons';
import {
  GreetingCard,
  GreetingSpace,
  GreetingAvatar,
  GreetingTitle,
  GreetingSubtitle,
  GreetingIconWrapper,
  GreetingText,
} from './Styles';
import { getGreetingTime } from './Constant';
import type { GreetingProps } from './types';

const Greeting: React.FC<GreetingProps> = ({ name, lastUpdated }) => {
  const timeOfDay = getGreetingTime();
  const greeting = `Good ${timeOfDay}, ${name}`;

  return (
    <GreetingCard>
      <GreetingSpace direction="vertical" size="middle">
        <Space size="middle" align="center">
          <GreetingAvatar size={48} icon={<FontAwesomeIcon icon={faUser} />} />
          <div>
            <GreetingTitle>{greeting}</GreetingTitle>
            <GreetingSubtitle>Welcome back to your dashboard</GreetingSubtitle>
          </div>
        </Space>

        <Space size="large">
          <Space size="small">
            <GreetingIconWrapper>
              <FontAwesomeIcon icon={faClock} />
            </GreetingIconWrapper>
            <GreetingText>Last updated {lastUpdated}</GreetingText>
          </Space>
          <Space size="small">
            <GreetingIconWrapper>
              <FontAwesomeIcon icon={faStore} />
            </GreetingIconWrapper>
            <GreetingText>Store Status: Active</GreetingText>
          </Space>
        </Space>
      </GreetingSpace>
    </GreetingCard>
  );
};

export default Greeting;